module.exports = __webpack_public_path__ + "static/media/HNTFIL.19053329.jpg";